import { useCallback, useState } from 'react'

export const useToggle = (initialState = false) => {
  const [toggled, setToggle] = useState(initialState)

  const toggle = useCallback(() => {
    setToggle(currentValue => !currentValue)
  }, [setToggle])

  const on = useCallback(() => {
    setToggle(true)
  }, [setToggle])

  const off = useCallback(() => {
    setToggle(false)
  }, [setToggle])

  return {
    toggle,
    off,
    on,
    value: toggled,
  }
}



// WEBPACK FOOTER //
// ./src/utils/hooks/useToggle.tsx